import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from "react-router-dom";
import { useContext } from 'react';
import RegisterContext from '../../contexts/RegisterContext';
import "./MenuTab.css"

function SlidingLogoutTab() {
    const route = useNavigate(); // variable to help route to different page
    // in order to show default page, user must be false
    // function to change this just in case user is true 
    // when button is clicked
    const {setUser,setShort,setNoMatch,setUnique} = useContext(RegisterContext);
    
    const logout = (e) => {
        console.log("logout")
        setUser(false)
        setShort(false)
        setNoMatch(false)
        setUnique(false)
        route("/")
    }

    return (
      <div className="slidetab">
         <div className="slide-innertab">
            <div className="slidetab-icontab" onClick={logout}>
               <FontAwesomeIcon icon={ faArrowRightFromBracket } className="iconTab" />
            </div>
            <p className="slidetab-text" onClick={logout}>Log Out</p>
         </div>
      </div>
   )
}

export default SlidingLogoutTab